import React from 'react';
import classnames from 'classnames';

import FilterSection from './FilterSection';
import {gettext} from '../../translations';
import {
    CUSTOM_DATE,
    EVENTBRITE_FORMAT_MAPPING_SEARCH,
    EVENTBRITE_FORMAT_TO_REFINEMENT,
    EVENTBRITE_CATEGORY_MAPPING_SEARCH,
    EVENTBRITE_CATEGORY_TO_REFINEMENT,
    DATES_MAPPING_SEARCH,
    DATES_TO_REFINEMENT,
    PRICE_MAPPING,
} from '../constants';
import invert from 'lodash/invert';
import withStickyScrollNewLayout from './withStickyScrollNewLayout';

import './FilterPanel.scss';

export class FilterPanelBase extends React.PureComponent {
    _handleChange = (key, value, shouldUpdateRoute) => {
        const {
            handleApplyFilter,
            handleRemoveFilter,
        } = this.props;

        if (value === 'all') {
            handleRemoveFilter({[key]: true});
        } else {
            handleApplyFilter({[key]: value}, {}, shouldUpdateRoute);
        }
    };

    _handleCustomDate = (startDate, endDate) => {
        const {
            handleApplyFilter,
        } = this.props;

        handleApplyFilter({dates: CUSTOM_DATE}, {startDate, endDate});
    };

    render() {
        const {isMobile} = this.props;
        const filterTitleContainer = (
            <header className="filter-title-container">
                <div className="filter-title">Filters</div>
                {
                    this.props.selectedFilterCount ? (
                        <a
                            className="filter-count-link eds-text-weight--heavy"
                            href={this.props.resetLink}
                        >
                            {gettext('Clear')}
                            <div className="filter-count eds-text-color--white eds-text-bs eds-l-mar-left-2">
                                {this.props.selectedFilterCount}
                            </div>
                        </a>
                    ) : null
                }
            </header>
        );

        return (
            <div className={
                classnames(
                    'filter-panel-and-title-container',
                    {'filter-panel-and-title-container--mobile': isMobile}
                )}
            >
                {filterTitleContainer}
                <section className={classnames('filter-panel', {'filter-panel--mobile': isMobile})}>
                    <FilterSection
                        title={gettext('Date')}
                        filters={{'all': gettext('Any day'), ...DATES_MAPPING_SEARCH}}
                        onOptionChange={(value, redirect) => this._handleChange('dates', value, redirect)}
                        onCustomDate={(startDate, endDate) => this._handleCustomDate(startDate, endDate)}
                        urlParameterMapping={invert(DATES_TO_REFINEMENT)}
                        moreLabel={gettext('More dates')}
                        lessLabel={gettext('Fewer dates')}
                        moreThreshold={5}
                        isDateSection={true}
                        filterType="date"
                    />
                    <FilterSection
                        title={gettext('Category')}
                        filters={{'all': gettext('Any category'), ...EVENTBRITE_CATEGORY_MAPPING_SEARCH}}
                        onOptionChange={(value, redirect) => this._handleChange('tags', value, redirect)}
                        urlParameterMapping={invert(EVENTBRITE_CATEGORY_TO_REFINEMENT)}
                        moreLabel={gettext('More categories')}
                        lessLabel={gettext('Fewer categories')}
                        moreThreshold={5}
                        filterType="category"
                    />
                    <FilterSection
                        title={gettext('Format')}
                        filters={{'all': gettext('Any format'), ...EVENTBRITE_FORMAT_MAPPING_SEARCH}}
                        onOptionChange={(value, redirect) => this._handleChange('format', value, redirect)}
                        urlParameterMapping={invert(EVENTBRITE_FORMAT_TO_REFINEMENT)}
                        moreLabel={gettext('More formats')}
                        lessLabel={gettext('Fewer formats')}
                        moreThreshold={5}
                        filterType="format"
                    />
                    <div className="eds-l-mar-bot-20">
                        <FilterSection
                            title={gettext('Price')}
                            filters={{'all': gettext('Any price'), ...PRICE_MAPPING}}
                            onOptionChange={(value, redirect) => this._handleChange('price', value, redirect)}
                            filterType="price"
                        />
                    </div>
                </section>
            </div>
        );
    }
}

export default withStickyScrollNewLayout(FilterPanelBase);
